var _style, _polygon, _rect, _text, _text2, _text3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 76.8 28.9",
    style: {
      enableBackground: "new 0 0 76.1 28.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#976DB2;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{font-family:'Lato-Hairline';}\r\n\t.st3{font-size:8.2736px;}\r\n\t.st4{font-family:'Lato-Regular';}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "25.1,13 25.1,2.2 20.6,2.2 14.5,19.1 13.8,21.3 13.2,22.9 12.7,21.5 12,19.3 6,2.2 1,2.2 1,26.3  4.2,26.3 4.2,5.8 11.5,26.3 14.5,26.3 21.9,6.2 21.9,13 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.9,
    y: 15.9,
    className: "st0",
    width: 3.2,
    height: 10.3
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 28.907 8.4654)",
    className: "st1 st2 st3"
  }, "MAHABUBA")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 28.907 16.858)",
    className: "st1 st2 st3"
  }, "AKTER")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 28.907 25.2457)",
    className: "st0 st1 st4 st3"
  }, "MURSONA")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo01);
export default __webpack_public_path__ + "static/media/logo-01.e731265a3f091165dcfdff5890366654.svg";
export { ForwardRef as ReactComponent };